import Model from "~/models/_Model";

export default class Setting extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courserecommendations";
  }

  // Set the resource route of the model
  resource() {
    return "settings";
  }

  relations() {
    return {};
  }
}
